import { Layout }         from 'antd';
import { useAppContext }  from '@/app/providers/baseProvider';
import logo               from '@/assets/image/foxconn_logo.png';

const { Footer: AntFooter } = Layout;

export const Footer = () => {
  const { isDarkMode } = useAppContext();

  return (
    <AntFooter
      style={{
        height: 60,
        padding: '0 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        marginTop: '60px',

        background: isDarkMode ? '#1f1f23' : '#ffffff',

        borderTop: isDarkMode
          ? '1px solid #303030'
          : '1px solid #f0f0f0',

        boxShadow: isDarkMode
          ? '0 -2px 8px rgba(0,0,0,0.25)'
          : '0 -2px 8px rgba(0,0,0,0.04)',
      }}
    >
      <img
        src={logo}
        alt="Foxconn logo"
        style={{
          height: 40,
          objectFit: 'contain',
          opacity: 0.9,
        }}
      />
    </AntFooter>
  );
}